import localStorage from "../utils/localStorage";
// import UtilsJS from "./utils"

const mutations = {
  // setLoading(state, loading) {
  //   state.loading = loading;
  // },
  setToken(state, token) {
    state.token = token;
    localStorage.set('token', token);
  },
  logout(state) {
    localStorage.remove('code');
    localStorage.remove('token');
    localStorage.remove('personName');
    localStorage.remove('phoneNumber');
    localStorage.remove('deliveryIdnumber');
    localStorage.remove('deliveryId');
    localStorage.remove('userId');
    localStorage.remove('openId');
    localStorage.remove('orgunit');
    state.token = '';
    state.userName = '';
    state.userinfo = '';
    state.personName = '';
    state.phoneNumber = '';
    state.deliveryIdnumber = '';
    state.deliveryId = '';
    state.userId = '';
  },
  setPersonName(state, personName) {
    state.personName = personName;
    localStorage.set('personName', personName);
  },
  setOrgunit(state, orgunit) {
    state.orgunit = orgunit;
    localStorage.set('orgunit', orgunit);
  },
  setPersonId(state, personId) {
    state.personId = personId;
    localStorage.set('personId', personId);
  },
  setPhoneNumber(state, phoneNumber) {
    state.phoneNumber = phoneNumber;
    localStorage.set('phoneNumber', phoneNumber);
  },
  setDeliveryIdnumber(state, deliveryIdnumber) {
    state.deliveryIdnumber = deliveryIdnumber;
    localStorage.set('deliveryIdnumber', deliveryIdnumber);
  },
  setDeliveryId(state, deliveryId) {
    state.deliveryId = deliveryId;
    localStorage.set('deliveryId', deliveryId);
  },
  setUserId(state, userId) {
    state.userId = userId;
    localStorage.set('userId', userId);
  },
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken;
    localStorage.set('accessToken', accessToken);
  },
  // setBreadcrumb(state, breadcrumb) {
  //   state.breadcrumb = breadcrumb;
  // },
  // setLayout(state, layout) {
  //   state.layout = layout
  // },
  // setSelectedMenu(state, menu) {
  //   state.selectedMenu = menu;
  // },
  // setUserName(state, name) {
  //   state.userName = name;
  //   Cookie.set('weteach_user_name', name);
  // },
  // setUserId(state, id) {
  //   state.userId = id;
  //   Cookie.set('weteach_user_id', id);
  // },
  // setTools(state, tools) {
  //   state.tools = tools;
  //   state.toolsArr = UtilsJS.fmtTools(tools);
  //   state.toolsStr = UtilsJS.getToolsStr(tools);
  //   Cookie.set('weteach_tools', tools);
  // },
}
export default mutations;